var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"smap-wrap d-flex"},[_c('div',{ref:"smap",staticClass:"smap",on:{"touchmove":function($event){$event.preventDefault();}}},[_vm._t("default",null,{"mapMethods":{ addAdditionalLayer: _vm.addAdditionalLayer },"map":_vm.map,"geometryLayer":_vm.geometryLayer})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }